import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Tr_Add from "./tr_add.js";
import Tr_Edit from "./tr_edit.js";

class Ls_edit extends React.Component {
  constructor(props, context) {
    super(props);

    //this.ta = props.store.ta;
    this.state = {};
    this.state.ynq = [];
    this.state.sval = [];

    this.state.dao = {};
    this.state.aa = [];
    this.state.cval = [
                {id: '001', text: 'ANTAL GER NYTT PRIS'},
                {id: '002', text: 'ANTAL GER RABATT PÅ PRIS'},
                {id: '003', text: 'PRISÄNDRING GENOM RABATT'}
            ];

    this.state.wnds = {};
    this.state.cols = {};
    this.state.lro = {};
    this.state.lso = {};
    this.state.lsa = [];
    if(props.wnds) {
        this.state.lro = props.wnds.lro;
        this.state.lso = props.wnds.lso;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //alert(JSON.stringify( this.state.lso ));
    //this.cdi_init();
    //this.syncCols("lsTable");
    this.ls_get();
  }
    cdi_init() {
        var self = this;

        var lro = {};
        lro.typ = "R";		    //[1];          /* TYP = R LÖNEKÖR     */
        lro.lrid = "";	        //[5];          /* Lönekör ID           */
        lro.datum = "20210101";		    //[8];          /* DATUM Lönekörning    */
        lro.text = "";		    //[30];         /* TEXT / INFO          */
        lro.fdat = "20210101";		    //[8];          /* Från datum           */
        lro.tdat = "20210131";	        //[8];          /* Till datum           */
        lro.betdat = "20210125";	    //[8];          /* Utbetlnigsdag        */
        lro.status = "";	    //[1];          /* Status               */
        lro.sign = "";	        //[3];          /* Signatur             */
        lro.filler = "";		//[6];
        lro.ts = "";		    //[46];
        lro.updtime = "";		//[4];          /* updtime              */

        self.setState({lro: lro});
    }
    cdi_store() {
        var self = this;
   }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    tab_head(tabid) {
      var css = {};
      css.background = "#fff";
      css.color = "#000";
      if(this.state.tabval === tabid) {
          css.background = "#080";
          css.color = "#fff";
      }
      return css;
    }
    grp_style(row) {
      var css = {};
      css.background = "#008";
      if(this.state.gnr === row.vgrupp) css.background = "#080";
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    ls_close = () => {
		this.props.ctx.setState({ wnds: {} });
	};

  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
    tr_add() {
      var wnds = {tradd: 1, lro: this.state.lro, lso: this.state.lso};
      this.setState({wnds: wnds});
    }
    tr_edit(row) {
      var wnds = {tredit: 1, lro: this.state.lro, lso: this.state.lso, tro: row};
      this.setState({wnds: wnds});
    }
    wnds_done(ctx, wnds) {
        ctx.ls_get();
        ctx.setState({wnds: {}});
    }
  ls_get() {
    var self = this;
    var prm = {};
    prm.req = "ta.ta_lon.ls_read";
    prm.lsid = this.state.lso.lsid;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        var lso = ret.rco;

        self.setState({lsa: lso.tra }, function() {
                self.syncCols("lsoTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  ls_save() {
    var self = this;

    //this.cdi_store();

    if(false){
      alert(JSON.stringify(this.state.lro));
      return;
    }

    var prm = {};
    prm.req = "ta.ta_lon.ls_add";
    prm.tlo = this.state.lso;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  ls_del() {
    var self = this;

    var prm = {};
    prm.req = "ta.ta_lon.ls_del";
    prm.tlo = this.state.lso;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        var rsp = {};
        rsp.wnd = "lsedit";
		self.props.ctx.wnds_done(self.props.ctx, rsp);
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var lso = this.state.lso;
      lso[name] = value;
      this.setState({lso: lso});
      //setState({[name]: value});
    }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };

  render() {
    if(!this.props.wnds.lsedit) return "";

    var title = this.props.title;
    if(!title) title = "Knappar";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_80 flex-col" style={ this.dlg_style() } draggable="true" >
        <div className="mx_h04">
            <div>LS</div>
        </div>
        <div className="mx_content flex">

            <div className="flex-row px-3">
                    <div className="flex-col flex">
                        <div>Lönespec:</div>
                        <div>{ this.state.lso.lsid.ztrim() } - { this.state.lso.datum.cdidate() }</div>
                    </div>
                    <div className="flex-col flex">
                        <div>Lönekörning:</div>
                        <div>{ this.state.lso.text }</div>
                    </div>
                    <div className="flex-col flex">
                        <div>Period:</div>
                        <div>{ this.state.lso.fdat }-{ this.state.lso.tdat }</div>
                    </div>
                    <div className="flex-col">
                        <div>Betaldag:</div>
                        <div>{ this.state.lso.betdat }</div>
                    </div>
           </div>
            <div className="flex-row px-3">
                    <div className="flex-col flex">
                        <div>Anställd:</div>
                        <div>{ this.state.lso.lsid.ztrim() } - { this.state.lso.datum }</div>
                    </div>
                    <div className="flex-col flex">
                        <div>Bank:</div>
                        <div>{ this.state.lso.text }</div>
                    </div>
                    <div className="flex-col flex">
                        <div>Skatt:</div>
                        <div>{ this.state.lso.tax }</div>
                    </div>
                    <div className="flex-col">
                        <div>Ändra</div>
                    </div>
           </div>
            <div className="divider_orange"></div>
            <div className="flex-row px-3">
                    <div className="flex-row flex">
                        <div>Antal Transaktioner:</div>
                        <div>0</div>
                    </div>
                    <div className="flex-row flex">
                        <div>Brutto:</div>
                        <div>0.00</div>
                    </div>
                    <div className="flex-row flex">
                        <div>Skatt:</div>
                        <div>0.00</div>
                    </div>
                    <div className="flex-row flex">
                        <div>Netto:</div>
                        <div>0.00</div>
                    </div>
                    <div className="flex-col">
                        <div>Uppdatera</div>
                    </div>
             </div>
            <div className="divider_green"></div>

            <div className="flex-col px-3">
            <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.cssCols("c01" ) }>Pos</th>
                    <th style={ this.cssCols("c02" ) }>Transaktion</th>
                    <th style={ this.cssCols("c03" ) }>Text</th>
                    <th style={ this.cssCols("c04" ) }>Antal</th>
                    <th style={ this.cssCols("c05" ) }>Enhet</th>
                    <th style={ this.cssCols("c06" ) }>Pris</th>
                    <th style={ this.cssCols("c07" ) }>Belopp</th>
                    <th style={ this.cssCols("c08" ) }>Skattesats</th>
                    <th style={ this.cssCols("c09" ) }>Tkn</th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
           <table id="lsoTable" className="table table-bordered table-hover tb">
                <tbody>
                { this.state.lsa.map((row, key) =>
                <tr key={ key } onDoubleClick={() => this.tr_edit(row) }>
                    <td>{ row.pos }</td>
                    <td>{ row.trans }</td>
                    <td>{ row.text }</td>
                    <td>{ row.nrof }</td>
                    <td>{ row.unit }</td>
                    <td>{ row.pris }</td>
                    <td>{ row.belopp.cdipris() }</td>
                    <td>{ row.tax }</td>
                    <td>{ row.tkn }</td>
                </tr>
                )}
                <tr style={{visibility: "hidden"}}>
                    <th>Pos</th>
                    <th>Transaktion</th>
                    <th>Text</th>
                    <th>Antal</th>
                    <th>Enhet</th>
                    <th>Pris</th>
                    <th>Belopp</th>
                    <th>Skattesats</th>
                    <th>Tkn</th>
                </tr>
                </tbody>
            </table>
            </div>
            </div>

        </div>
        <div className="divider_green"></div>
        <div className="flex-row px-3 pb-1">
                <div className="flex-col">
                    <div className="btn_link" onClick={() => this.tr_add() }>Lägg till transaktion</div>
                </div>
                <div className="flex"></div>
                <div className="flex-col">
                </div>
         </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.ls_close() } >
                STÄNG
            </button>
            <button className="btn btn-hw-green w250" onClick={() => this.ls_del() } >
                TA BORT
            </button>
            <button className="btn btn-hw-green w250" onClick={() => this.ls_prn() } >
                SKRIV UT
            </button>
        </div>
      </div>

    { this.state.wnds.tradd ? <Tr_Add wnds={this.state.wnds} ctx={this} lso={this.state.lso} backdrop={true}/> : null }
    { this.state.wnds.tredit ? <Tr_Edit wnds={this.state.wnds} ctx={this} lso={this.state.lso} backdrop={true}/> : null }
      </div>
	;
	return html;
  };
}

export default Ls_edit;